import { types, successAction } from "@authzsvc/api-lib";

export default (state = [], action) => {
  switch (action.type) {
    case successAction(types.GET_PROVIDERS):
      return action.payload.data;
    default:
      return state;
  }
};
